import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = ({ 
  activeTab, 
  onTabChange, 
  navItems,
  className = ""
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleTabClick = (item) => {
    onTabChange(item.name);
    setIsMobileMenuOpen(false);
  };

  return (
    <div className={className}>
      {/* Desktop Navigation */}
      <nav className="hidden sm:flex items-center space-x-2" aria-label="Main navigation">
        {navItems.map((item) => (
          <button
            key={item.name}
            onClick={() => onTabChange(item.name)}
            className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap ${
              activeTab === item.name
                ? 'bg-yellow-500 text-black shadow-lg'
                : 'text-gray-300 hover:text-white hover:bg-gray-700'
            }`}
            aria-current={activeTab === item.name ? 'page' : undefined}
          >
            {item.name}
          </button>
        ))}
      </nav>

      {/* Mobile Navigation */}
      <div className="sm:hidden">
        <button
          className="text-gray-300 hover:text-white transition-colors duration-300"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <div 
          className={`absolute top-full left-0 right-0 transition-all duration-300 overflow-hidden z-50 ${
            isMobileMenuOpen ? 'max-h-64 mt-4' : 'max-h-0'
          }`}
        >
          <nav className="bg-gray-700 rounded-lg mx-6 p-4 space-y-2 shadow-xl" aria-label="Mobile navigation">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleTabClick(item)}
                className={`block w-full text-left px-4 py-3 rounded-lg font-medium transition-all duration-300 ${
                  activeTab === item.name
                    ? 'bg-yellow-500 text-black shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-gray-600'
                }`}
                aria-current={activeTab === item.name ? 'page' : undefined}
              >
                {item.name}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navigation;